export const PLAYBACK_SPEED_OPTIONS = [
  { value: "0.1", label: "0.1x" },
  { value: "0.15", label: "0.15x" },
  { value: "0.25", label: "0.25x" },
  { value: "0.5", label: "0.5x" },
  { value: "0.8", label: "0.8x" },
  { value: "1", label: "1.0x" },
  { value: "1.5", label: "1.5x" },
  { value: "2", label: "2.0x" },
  { value: "2.5", label: "2.5x" },
  { value: "3", label: "3.0x" },
];
